var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 323 323",
    style: {
      enableBackground: "new 0 0 323 323"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#575651;stroke-width:6.8176;}\r\n\t.st1{fill:#575651;}\r\n\t.st2{fill:#DE996F;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79,45.4h165c3.6,0,6.6,3,6.6,6.6v220c0,3.6-3,6.6-6.6,6.6H79c-3.6,0-6.6-3-6.6-6.6V52 C72.4,48.4,75.4,45.4,79,45.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.5,159h115c1.9,0,3.5,1.6,3.5,3.5l0,0c0,1.9-1.6,3.5-3.5,3.5h-115c-1.9,0-3.5-1.6-3.5-3.5l0,0 C109,160.6,110.6,159,112.5,159z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113,198h114c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4H113c-2.2,0-4-1.8-4-4l0,0C109,199.8,110.8,198,113,198z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113,238h84c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4h-84c-2.2,0-4-1.8-4-4l0,0C109,239.8,110.8,238,113,238z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113,99h114c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4H113c-2.2,0-4-1.8-4-4l0,0C109,100.8,110.8,99,113,99z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113,139h114c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4H113c-2.2,0-4-1.8-4-4l0,0C109,140.8,110.8,139,113,139z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113,178h114c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4H113c-2.2,0-4-1.8-4-4l0,0C109,179.8,110.8,178,113,178z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113,218h90c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4h-90c-2.2,0-4-1.8-4-4l0,0C109,219.8,110.8,218,113,218z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113,79h114c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4H113c-2.2,0-4-1.8-4-4l0,0C109,80.8,110.8,79,113,79z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113,119h114c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4H113c-2.2,0-4-1.8-4-4l0,0C109,120.8,110.8,119,113,119z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 97,
    cy: 81.5,
    rx: 6,
    ry: 5.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 97,
    cy: 102.5,
    rx: 6,
    ry: 5.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 97,
    cy: 122.5,
    rx: 6,
    ry: 5.5
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 97,
    cy: 142.5,
    rx: 6,
    ry: 5.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 97,
    cy: 162.5,
    rx: 6,
    ry: 5.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 97,
    cy: 181.5,
    rx: 6,
    ry: 5.5
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 97,
    cy: 201.5,
    rx: 6,
    ry: 5.5
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 97,
    cy: 221.5,
    rx: 6,
    ry: 5.5
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 97,
    cy: 241.5,
    rx: 6,
    ry: 5.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractBronze);
export default __webpack_public_path__ + "static/media/contract-bronze.c9138d2ad8051ac6309c443f71701323.svg";
export { ForwardRef as ReactComponent };